<template>
    <section>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label><i class="fa fa-user"></i> Nome</label>
                    <input :class="{'is-invalid':errors.has('nome')}" v-validate="{required:true}"
                        v-model="request.assinatura_nome" name="nome" class="form-control"
                        placeholder="Insira o nome completo">
                    <div class="invalid-feedback help-block error">{{errors.first('nome')}}</div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label><i class="fa fa-envelope"></i> Email</label>
                    <input :class="{'is-invalid':errors.has('email')}" v-validate="{required:true, email: true}"
                        v-model="request.assinatura_email" name="email" class="form-control"
                        placeholder="Insira o e-mail">
                    <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <p><b>Possui CPF?</b> (Se NÃO será solicitado na assinatura)</p>
                    <p-radio name="hasDocument" :color="appLayout.check" v-model="request.hasDocument" :value="true">Sim
                    </p-radio>
                    <p-radio name="hasDocument" :color="appLayout.check" v-model="request.hasDocument" :value="false">
                        Não
                    </p-radio>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label :class="{ 'text-danger': errors.has('Documento') }"><i class="fa fa-list-alt"></i>
                        CPF</label>
                    <input v-mask="'###.###.###-##'" v-validate="{required: true, document: true}"
                        :class="{ 'is-invalid': errors.has('Documento') }" :disabled="!request.hasDocument"
                        class="form-control" name="Documento" v-model="request.assinatura_documento"
                        placeholder="Documento">
                    <div class="invalid-feedback help-block error">{{errors.first('Documento')}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label><i class="fa fa-pencil"></i> Tipo de assinatura</label>
                    <select :class="{'is-invalid':errors.has('tipo')}" v-validate="{required:true}"
                        v-model="request.assinatura_tipo" class="form-control" name="tipo">
                        <option selected="selected" :value="null">{{$t('words.select')}}</option>
                        <option value="1">Assinar</option>
                        <option value="2">Aprovar</option>
                        <option value="3">Reconhecer</option>
                        <option value="4">Assinar como parte</option>
                        <option value="5">Assinar como testemunha</option>
                        <option value="6">Assinar como interveniente</option>
                        <option value="7">Acusar recebimento</option>
                        <option value="8">Dar ciência</option>
                    </select>
                    <div class="invalid-feedback help-block error">{{errors.first('tipo')}}</div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label><i class="fa fa-shield"></i> Autenticação por Token</label>
                    <select :class="{'is-invalid':errors.has('autenticacao')}" v-validate="{required:true}"
                        v-model="request.token_tipo" class="form-control" name="autenticacao">
                        <option value="E">E-mail</option>
                        <option value="M">Celular</option>
                    </select>
                    <div class="invalid-feedback help-block error">{{errors.first('autenticacao')}}</div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label><i class="fa fa-mobile"></i> Celular</label> (Serviço cobrado)
                    <input v-model="request.assinatura_telefone" class="form-control"
                        v-mask="['(##)####-####', '(##)#####-####']" :disabled="request.token_tipo != 'M'"
                        placeholder="Digite o número">
                    <div class="invalid-feedback help-block error">{{errors.first('tipo')}}</div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        inject: ['$validator'],
        props: {
            request: {}
        }
    }
</script>